import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_SM_FACTORY_CERTIFICATIONS',
  'UPDATE_SM_FACTORY_CERTIFICATIONS_PARAMS' // It includes sorter,filter,pagination
);
